import * as React from 'react';
import { Grid, FormGroup, Checkbox, FormControlLabel, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { AMENITY_SPACE_STATUS } from '../../../../../constants/event-application-status';

export default function FeaturesCheckBoxes({ features, handleChange, selectedFeatures }) {
  function isChecked(feature) {
    return selectedFeatures.includes(feature);
  }

  return (
    <FormGroup>
      {features.map(
        (feature) =>
          feature.status === AMENITY_SPACE_STATUS.ENABLED && (
            <div key={`${feature.fk_venue}-${feature.fk_feature}`}>
              <Grid container justifyContent="space-between">
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked(feature)}
                        onChange={handleChange}
                        name={feature.name}
                      />
                    }
                    label={feature.name}
                  />
                </Grid>
                <Grid item>
                  <Typography color="#0997BA">$ {feature.price} USD</Typography>
                </Grid>
              </Grid>
            </div>
          ),
      )}
    </FormGroup>
  );
}

FeaturesCheckBoxes.propTypes = {
  features: PropTypes.instanceOf(Array),
  selectedFeatures: PropTypes.instanceOf(Array),
  handleChange: PropTypes.func,
};

FeaturesCheckBoxes.defaultProps = {
  features: [],
  selectedFeatures: [],
  handleChange: () => {},
};
